$(document).ready(function () {

    var initMenuOverrides = function () {

        var $navbarToggler = $('button.navbar-toggler');
        var $navbar = $($navbarToggler.attr('data-target'));

        // When toggling menu (normally mobile menu), lookup active items
        // and add trigger 'show' in order to expand dropdown menus (if any)
        $navbarToggler.on('click.furillo', function (e) {

            // When desktop or when closing there's no need to run this
            if (!$navbarToggler.is(':visible') || $(this).attr('aria-expanded') === 'true') {
                return;
            }
            
            $('.nav-item.dropdown.active', $navbar).each(function () {
                $('.collapse', $(this)).first().collapse('show');
            });
        });

        // Since we use BS 'collapse' rather than 'dropdown' for menu we need
        // to add this to close all open collapses when clicking outside of the menu.
        $(document).on('click.furillo', function (e) {

            // If on mobile or still within the navbar, no need to run this
            if ($navbarToggler.is(':visible') || $(e.target).parents('.navbar').length > 0)
                return;

            $('.collapse.show').collapse('hide');
        });


        var timeoutId = null;
        $navbar.on('mouseover.furillo', '.nav-item.dropdown', function (e) {
            
            // If on mobile there's no need to run this
            if ($navbarToggler.is(':visible'))
                return;

            var $this = $(this);

            // If already open (like the parent), no need to run
            if ($('.collapse.show', $this).first().length > 0) {
                return;
            }
            
            if (timeoutId !== null) {
                clearTimeout(timeoutId);
            }

            timeoutId = setTimeout(function() {
                $('.collapse', $this).first().collapse('show');

                // Always only one open
                $this.siblings('.nav-item.dropdown').each(function () {
                    $('.collapse.show', this).first().collapse('hide');
                });

                timeoutId = null;
            }, 250);
        });

        $navbar.on('mouseleave.furillo', '.nav-item.dropdown', function (e) {

            // If on mobile there's no need to run this
            if ($navbarToggler.is(':visible'))
                return;

            $('.collapse.show', this).first().collapse('hide');
        });
    };

    initMenuOverrides();
    
    $(document).on('click', '[data-toggle="lightbox"]', function (e) {
        e.preventDefault();
        $(this).ekkoLightbox({
            showArrows: true
        });
    });

    $(document).on('click', '.cookies-close', function () {
        var $moduleBody = $(this).parent().parent();
        $moduleBody.addClass('pressed');
        var $moduleBodyHeight = $moduleBody.outerHeight();
        $moduleBody.css('bottom', -$moduleBodyHeight);

        setTimeout(function () {
            var days = 30;
            var date = new Date();
            date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));

            var expires = date.toGMTString();
            document.cookie = 'accepted_cookies=true; expires=' + expires + '; path=/';
        }, 260);
    });

    $('#action-modal').on('show.bs.modal', function(e) {
        var $modal = $(this);
        var $btn = $(e.relatedTarget);
        if ($btn.hasClass('disabled') || $btn.is(':disabled')) {
            e.preventDefault();
            return;
        }

        var url = $btn.data('url');
        if (!url || url.length === 0)
            url = $btn.attr('href');

        if (url === '#') {
            // Just display the standard content
            $('.partial-view', $modal).show();
            $('.loader', $modal).hide();
            return;
        }

        $('.partial-view', $modal).hide();
        $('.loader', $modal).show();

        $('.partial-view', $modal).html('').load(url, function() {
            $('.partial-view', $modal).show();
            $('.loader', $modal).hide();
        });
    });

    $('#action-modal').on('hide.bs.modal', function () {
        
        var $btn = $(document.activeElement); // No relatedTarget on hide event
        if (!$btn)
            return;

        var url = '';
        if ($btn.data('reload') === 'true')
            url = window.location.href;
        else if ($btn.data('redirecturl') && $btn.data('redirecturl').length > 0)
            url = $btn.data('redirecturl');

        if (url.length > 0) {
            window.location.href = url;
        }
    });

    $('.umbraco-forms-form.ajax form').formsAjaxPost();


    $('.tag-filters').tagfilter();
    $('#to-top').totop();

    // For async loading of navigation
    $('div[data-ajax="true"],ul[data-ajax="true"]').each(function() {
        var element = $(this);

        var method = element.data('ajax-method');
        var mode = element.data('ajax-mode');
        var target = $(element.data('ajax-update'));
        var href = element.attr('href');

        // Extend this later on for more modes and methods
        if (method !== 'GET') {
            element.remove();
            return;
        }

        // If on mobile, use different method
        if ($('button.navbar-toggler').is(':visible')) {
            href = href.replace('Navigation/', 'NavigationMobile/');
        }

        $.get(href, function (data) {

            if (data == null || data.length === 0) {
                // If no data, remove both the trigger and "self"
                var id = element.attr('id');
                element.siblings('[data-target="#' + id + '"]').remove();
                element.remove();
                return;
            }

            target.html(data);
        });
    });

    var frames = $(".lazyframe");
    if (frames && frames.length > 0) {
        lazyframe(frames);   
    }

    
});


$(window).scroll(function () {
    if ($('#to-top').data('totop')) {
        $('#to-top').data('totop').scrolling();
    }
});

$(window).resize(function () {
    if ($('#to-top').data('totop')) {
        $('#to-top').data('totop').resize();
    }
});